import { render, staticRenderFns } from "./IbInfoModalMarkdown.vue?vue&type=template&id=b6439f16"
import script from "./IbInfoModalMarkdown.vue?vue&type=script&lang=js"
export * from "./IbInfoModalMarkdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports